import moment from 'moment-timezone';
import { useEffect, useState } from "react";

const CountDown = () => {
    const [countdown, setCountdown] = useState<string>('');
    const [isBirthday, setIsBirthday] = useState<boolean>(false);
    useEffect(() => {
        const calculateCountdown = () => {
            const now = moment();
            var year = (now.date() >= 9 && now.month() >= 10) ? now.year() + 1 : now.year();
            const targetDate = moment(`${year}-10-09T00:00:00Z`);

            const duration = moment.duration(targetDate.diff(now));

            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();
            const seconds = duration.seconds();

            setCountdown(`${days} ngày ${hours} giờ ${minutes} phút `);
        };

        const timer = setInterval(() => {
            calculateCountdown();
        }, 1000);

        return () => clearInterval(timer);

    }, []);

    useEffect(() => {
        const now = moment();
        if (now.date() == 9 && now.month() == 10) {
            setIsBirthday(true);
        }
    }, []);

    return (<>
        {isBirthday ? <span>Chúc mừng Ngày thành lập Quỹ (09-10)</span> : <span>Còn {countdown} <br /> đến ngày thành lập Quỹ (09 - 10 - 2007) </span>
        }
    </>
    );
};

export default CountDown;
